export default __webpack_public_path__ + "static/media/bannerCopiadoras.edcb1334.svg";